export default __webpack_public_path__ + "static/media/hand-selector.1d2e3ab9.svg";